export const defaultFilterFields = {
  to: null,
  next: null,
  last: null,
  from: null,
  uuid: null,
  groupId: null,
  timeUnit: null,
  dataType: null,
  operation: null,
  stringValue: null,
  stringRange: null,
  numberRange: null,
  numberValue: null,
  booleanValue: null,
  propertyName: null,
  dateRelative: false,
};

export const rangeObject = {
  to: null,
  from: null,
};
